module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00020-fs8.4c378e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00020-fs8.png
// module id = 173
// module chunks = 0